import { z } from 'zod'

export const changeRequestCreateSchema = z.object({
  page: z.string().min(1, 'Page is required'),
  element_description: z.string().min(1, 'Element description is required'),
  change_description: z.string().min(1, 'Change description is required'),
  priority: z.enum(['low', 'medium', 'high']),
})

export const changeRequestUpdateSchema = z.object({
  status: z.enum(['submitted', 'in_progress', 'completed']).optional(),
  due_at: z.string().datetime().optional(),
  github_path: z.string().optional(),
})
